import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";

window.Hls = Hls;
window.Plyr = Plyr;

window.initializeRecastPlayer = function (selector, options = {}) {
    const player = document.querySelector(selector);

    if (!player) {
        return null;
    }

    const source = options.source || player.dataset.src;
    const controls = options.controls || ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'pip', 'airplay', 'fullscreen'];
    const plyr = new Plyr(player, {
        ratio: options.ratio || '16:9',
        controls,
    });

    if (!source) {
        return { player, plyr, hls: null };
    }

    if (Hls.isSupported()) {
        const hls = new Hls({
            enableWorker: true,
            lowLatencyMode: true,
            liveSyncDurationCount: 3,
            maxLiveSyncPlaybackRate: 1.5,
        });

        hls.on(Hls.Events.ERROR, (event, data) => {
            if (!data.fatal) {
                return;
            }

            if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
                hls.startLoad();
                return;
            }

            if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
                hls.recoverMediaError();
            }
        });

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
            const seekableEnd = player.seekable?.length ? player.seekable.end(player.seekable.length - 1) : null;

            if (seekableEnd && Number.isFinite(seekableEnd)) {
                player.currentTime = Math.max(0, seekableEnd - 2);
            }
        });

        hls.loadSource(source);
        hls.attachMedia(player);

        return { player, plyr, hls };
    }

    if (player.canPlayType('application/vnd.apple.mpegurl')) {
        player.src = source;
    }

    return { player, plyr, hls: null };
};
